import React, { useEffect, useState } from "react";
import { ValidatorForm } from "react-form-validator-core";
import Header from "../layout/Header";
import SelectValidator from "../partial/SelectValidator";
import { getDropdownObject } from "../../utils/helper";
import { getEventItemsList, getEventTypeName } from "../pages/campaigns/services";
import { Link, useNavigate } from "react-router-dom";
import { backIcon2 } from "../../Image/Index";

function CreateAction() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [state, setState] = useState({
    name: "",
    eventType: "",
    transactionType: "Pre",
    client: "",
    status: false,
    description: "",
    selectedEvent: ""
  });
  const { name, eventType, transactionType, client, status, description, selectedEvent } =
    state;
  const [eventTypeOpt, setEventTypeOpt] = useState([]);
  const [eventListOpt, setEventListOpt] = useState([{ value: "", label: "Select" }]);

  const [transTypeDisplay] = useState([
    { value: "Pre", label: "Pre" },
    { value: "Post", label: "Post" },
  ]);

  useEffect(() => {
    fetchEventItemsList();
  }, []);

  useEffect(() => {
    if (eventType) {
      fetchEventTypeName();
    } else {
      // Reset event list when no event type is selected
      setEventListOpt([{ value: "", label: "Select" }]);
      setState(prev => ({ ...prev, selectedEvent: "" }));
    }
  }, [eventType]);

  const fetchEventItemsList = async () => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("token_gen"));
    const eventList = await getEventItemsList(token?.access_token);
    if (eventList.message === "Request processed successfully.") {
      if (eventList?.data?.eventItemsList?.length > 0) {
        setEventTypeOpt(() =>
          eventList?.data?.eventItemsList.map((ele) => {
            return {
              value: ele,
              label: ele,
            };
          })
        );
        setState((prev) => ({
          ...prev,
          eventType: eventList?.data?.eventItemsList[0],
        }));
      }
    }
    setLoader(false);
  };

  const fetchEventTypeName = async () => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("token_gen"));
    const response = await getEventTypeName(token?.access_token, eventType);
    
    let options = [{ value: "", label: "Select" }];
    
    if (response.message === "Request processed successfully." && response?.data?.length > 0) {
      options = [
        { value: "", label: "Select" },
        ...response.data.map(ele => ({
          value: ele.eventName,
          label: ele.eventName
        }))
      ];
    }
    
    setEventListOpt(options);
    setState(prev => ({
      ...prev,
      selectedEvent: ""
    }));
    setLoader(false);
  };

  const onChange = (e) => {
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  
  const onSelectChange = (e, name) => {
    setState((prev) => ({
      ...prev,
      [name]: e.value,
    }));
  };
  
  const handleToggle = (e) => {
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.checked,
    }));
  };

  return (
    <div>
      <Header name={"Action Management"} />
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <div className="dashboard__content">
        <div className="container-fluid">
          <div className="dashboard__profileSettingsMain">
            <div className="dashboard__heading">
              <div className="dashboard__headingLeft">
                <div className="dashboard__headingBackLink">
                  <Link to="" onClick={() => navigate(-1)}>
                    <img src={backIcon2} alt="" />
                    <div className="dashboard__headingContent">
                      <h3>Event Management</h3>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <ValidatorForm
              className="dashboard__profileSettingsBox"
              // onSubmit={onSubmit}
            >
              <div className="customForm customForm_2">
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="form-group withIcon">
                      <label>Event Type</label>
                      <SelectValidator
                        placeholder="Select Type"
                        className="custom-ReactSelect bordered"
                        name="eventType"
                        value={getDropdownObject(eventType, eventTypeOpt)}
                        options={eventTypeOpt}
                        onChange={(e) => onSelectChange(e, "eventType")}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="form-group withIcon">
                      <label>List of Event</label>
                      <SelectValidator
                        placeholder="Select Event"
                        className="custom-ReactSelect bordered"
                        name="selectedEvent"
                        value={getDropdownObject(selectedEvent, eventListOpt)}
                        options={eventListOpt}
                        onChange={(e) => onSelectChange(e, "selectedEvent")}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                    <div
                      className="person"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <p
                        className="voucher mb-2"
                        style={{
                          display: "flex",
                          width: "25%",
                          marginBottom: "0",
                          color: "black",
                        }}
                      >
                        Status
                      </p>
                      <div className="">
                        <label className="toggle">
                          <input
                            type="checkbox"
                            name="status"
                            checked={status}
                            onChange={handleToggle}
                          />
                          <span className="slider"></span>
                          <span
                            className="labels"
                            data-on="Active"
                            data-off="InActive"
                          ></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="form-group withIcon">
                      <label>Action Type</label>
                      <SelectValidator
                        placeholder="Select Type"
                        className="custom-ReactSelect bordered"
                        name="transactionType"
                        value={getDropdownObject(
                          transactionType,
                          transTypeDisplay
                        )}
                        options={transTypeDisplay}
                        onChange={(e) => onSelectChange(e, "transactionType")}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 py-3">
                    <div
                      className="button-section"
                      style={{ justifyContent: "flex-end", display: "flex" }}
                    >
                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ValidatorForm>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateAction;